//   Generated by Paratype Generator

import { CommonModule } from '@angular/common';
import { Component, forwardRef, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TableColumnV2Component } from '@common/components/table-column/table-column-v2.component';
import { FilterColumn } from '@common/models/filter-column';
import { PlainMonthPipe } from '@common/pipes/plain-date.pipe';
import { FacturaDTO } from '@gen/factura/factura.dto';
import { FacturaService } from '@gen/factura/factura.service';
import { EntityType, FacturaStatus } from '@gen-common/enums';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { Toast } from 'primeng/toast';
import { BaseTableV2 } from 'src/app/common/components/base-table.component-v2';

@Component({
  selector: 'app-factura-owner-table',
  templateUrl: './factura-owner-table.component.html',
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputIconModule,
    IconFieldModule,
    InputTextModule,
    TranslocoModule,
    TableColumnV2Component,
    Toast,
    SkeletonModule,
    DialogModule,
    PlainMonthPipe
  ],
  providers: [
    FacturaService,
    {
      provide: BaseTableV2<FacturaDTO>,
      useExisting: forwardRef(() => FacturaOwnerTableComponent)
    }
  ],
  standalone: true
})
export class FacturaOwnerTableComponent extends BaseTableV2<FacturaDTO> {
  override translocoService = inject(TranslocoService);
  private sanitizer = inject(DomSanitizer);

  protected override quickFilterColumns: FilterColumn[] = [];

  statusOptions: { label: string; value: FacturaStatus }[] = [];

  override entityService = inject(FacturaService);
  override entityName = 'factura';
  override entityType = EntityType.FACTURA;

  override countOfColumns = 6;

  override filterColumns: FilterColumn[] = [
    { name: 'number', label: 'factura.number', type: 'Text', enumType: 'string' },
    { name: 'period', label: 'common.period', type: 'month' },
    { name: 'property__unit_name', label: 'common.property', type: 'Text', enumType: 'Property' },
    { name: 'owner__name', label: 'owner.name', type: 'Text', enumType: 'Owner' },
    { name: 'balance', label: 'common.balance', type: 'Text', enumType: 'number' }
  ];

  override async loadEntities(requestId: number): Promise<void> {
    const response = await this.entityService.getFilteredWithCounter(this.filter);
    if (!this.isCurrentLoadRequest(requestId)) {
      return;
    }
    this.entities = response.body;
    this.entitiesCount = Number(response.headers.get('x-total-count'));
  }

  previewDialogVisible = false;
  previewUrl: SafeResourceUrl | null = null;

  previewFactura(event: any) {
    this.previewDialogVisible = true;
    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`/api/ext-factura/test-preview/${event.data.id}`);
  }

  clearPreviewUrl() {
    this.previewUrl = null;
  }
}
